import { useNavigate, useLocation } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleNavigation = (path) => {
    if (location.pathname === path) {
      // Already on this page, scroll to top
      scrollToTop();
    } else {
      // Navigate to the page and scroll to top
      navigate(path);
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    }
  };

  const scrollToSection = (sectionId) => {
    if (location.pathname === '/') {
      // Already on home page, just scroll to section
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // Navigate to home and then scroll to section
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and Description */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-6 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_3ad0df18-66ae-47af-92fb-c4edc5379868/artifacts/ejvn3pae_High%20Res%20Logo.jpg" 
                alt="Original Bull Logo" 
                className="h-16 w-auto bg-white rounded-lg p-2"
              />
              <a 
                href="https://australianmade.com.au" 
                target="_blank" 
                rel="noopener noreferrer"
                title="Australian Made"
                className="p-2"
              >
                <img 
                  src="https://customer-assets.emergentagent.com/job_185b30bf-6e94-434b-8e3e-3ca910668034/artifacts/lq4m5jia_AMCL%20Logo.jpg" 
                  alt="Australian Made Logo" 
                  className="h-14 w-auto mix-blend-multiply"
                />
              </a>
            </div>
            <p className="text-gray-400 max-w-md">
              Two centuries of South African tradition, perfected with premium Australian beef. Proudly Australian Made.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <button onClick={() => handleNavigation('/')} className="text-gray-400 hover:text-white transition-colors text-left">
                  Home
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('products')} className="text-gray-400 hover:text-white transition-colors text-left">
                  Products
                </button>
              </li>
              <li>
                <button onClick={() => handleNavigation('/steak')} className="text-gray-400 hover:text-white transition-colors text-left">
                  Steak Range
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('heritage')} className="text-gray-400 hover:text-white transition-colors text-left">
                  Heritage
                </button>
              </li>
              <li>
                <button onClick={() => handleNavigation('/wholesale')} className="text-gray-400 hover:text-white transition-colors text-left">
                  Wholesale
                </button>
              </li>
              <li>
                <button onClick={() => handleNavigation('/shop')} className="text-gray-400 hover:text-white transition-colors text-left">
                  Shop
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-gray-400 hover:text-white transition-colors text-left">
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-bold text-lg mb-4">Contact Us</h3>
            <ul className="space-y-2 text-gray-400">
              <li>Southern Highlands, NSW</li>
              <li>Australia</li>
              <li className="pt-2">
                <a href="mailto:info@originalbull.com" className="hover:text-white transition-colors">
                  info@originalbull.com
                </a>
              </li>
              <li>
                <a href="tel:+61290373883" className="hover:text-white transition-colors">
                  +61 2 9037 3883
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © 2025 Original Bull Pty Ltd. All rights reserved.
            </p>
            <div className="flex gap-6">
              <button onClick={() => handleNavigation('/disclaimer')} className="text-gray-400 hover:text-white transition-colors text-sm">
                Disclaimer
              </button>
              <button onClick={() => handleNavigation('/privacy')} className="text-gray-400 hover:text-white transition-colors text-sm">
                Privacy Policy
              </button>
              <button onClick={() => handleNavigation('/terms')} className="text-gray-400 hover:text-white transition-colors text-sm">
                Terms & Conditions
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;